// Verrou d'écran.
// Sans ça l'écran s'éteint en pleine tournée et le guidage disparaît. Le navigateur relâche
// le verrou dès que l'onglet passe en arrière-plan, d'où le réarmement sur visibilitychange
// et au toucher.
//
// `isActive` est injecté plutôt que lu dans une globale : le module reste utilisable et
// testable hors de l'application.

let wakeLock = null;
let isActive = () => false;

function setWakeLockGuard(fn) { isActive = fn; }

async function requestWakeLock() {
    if (wakeLock || !isActive()) return;
    if (!('wakeLock' in navigator)) return;   // absent sur Firefox et iOS < 16.4
    try {
        const lock = await navigator.wakeLock.request('screen');
        wakeLock = lock;
        lock.addEventListener('release', () => { if (wakeLock === lock) wakeLock = null; });
    } catch (e) { wakeLock = null; }          // refusé : batterie faible, onglet caché
}

function releaseWakeLock() {
    if (!wakeLock) return;
    try { wakeLock.release(); } catch (e) {}
    wakeLock = null;
}

function installWakeLockListeners() {
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') requestWakeLock();
    });
    ['touchstart', 'pointerdown'].forEach(ev =>
        document.addEventListener(ev, () => requestWakeLock(), { passive: true }));
}

export { setWakeLockGuard, requestWakeLock, releaseWakeLock, installWakeLockListeners };
